import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from '../EditableTable/types';

const columns: ColumnSettings[] = [
  {
    name: 'name',
    title: 'Name',
    sortable: true,
  },
  {
    name: 'abbreviation',
    title: 'Abbreviation',
    sortable: true,
  },
];

const CommonTests = (): React.ReactElement => (
  <div>
    <h1 className="shared-font headline">Common Tests</h1>
    <EditableTable
      basePath="/v1/admin/common-tests"
      defaultSortKey="name"
      columns={columns}
      identifier="common-tests"
    />
  </div>
);

export default CommonTests;
